
import type React from "react"

import { useState, useEffect } from "react"
import ImageViewer from "./ImageViewer"

interface ClickableImageProps {
  src: string
  alt?: string
  className?: string
  style?: React.CSSProperties
}

const ClickableImage = ({ src, alt = "", className = "", style }: ClickableImageProps) => {
  const [isViewerOpen, setIsViewerOpen] = useState(false)
  const [isMounted, setIsMounted] = useState(false)

  // Only render the portal on the client side
  useEffect(() => {
    setIsMounted(true)
  }, [])

  return (
    <>
      <img
        src={src || "/placeholder.svg"}
        alt={alt}
        className={`cursor-pointer ${className}`}
        style={style}
        onClick={() => setIsViewerOpen(true)}
      />
      {isMounted && (
        <ImageViewer isOpen={isViewerOpen} imageUrl={src} alt={alt} onClose={() => setIsViewerOpen(false)} />
      )}
    </>
  )
}

export default ClickableImage

